export const queryKeys = {
  auth: ["auth"] as const,
  me: ["auth", "me"] as const,
  csrf: ["auth", "csrf"] as const,
  dashboard: ["dashboard"] as const,
  snapshot: (id: string) => ["dashboard", "snapshot", id] as const,
};
